@let dataExists = dataExists$ | async;

<div mat-dialog-title>
  <span class="text-xl font-bold">
    {{
      'raw-data.info.ADD_ROW' | transloco
    }}
  </span>
</div>

<mat-dialog-content class="w-full h-full" [formGroup]="formGroup">
  <div class="flex flex-col gap-4">
    <div class="flex w-full gap-4">
      <div class="w-1/2">
        <mat-form-field class="w-full">
          <mat-label>{{
              'raw-data.filters.PRODUCT_GROUP' | transloco
            }}
          </mat-label>
          <mat-select formControlName="identifierCategoriesFormControl">
            @for (i of timeSeriesIdentifierCategoriesLocalized$ | async;
              track i.id) {
              <mat-option [value]="i">{{ i.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="w-1/2">
        <ng-select
          [items]="identifiers$ | async"
          [searchable]="true"
          appendTo="body"
          [clearable]="true"
          formControlName="identifier"
          placeholder="{{ 'raw-data.filters.IDENTIFIER' | transloco }}"
        >
        </ng-select>
      </div>
    </div>

    <div class="flex w-full gap-4">
      <div class="w-1/2">
        <mat-form-field class="w-full" (click)="picker.open()">
          <mat-label>{{ 'raw-data.filters.LISTING_DATE' | transloco }}</mat-label>
          <input
            matInput
            formControlName="date"
            [matDatepicker]="picker"
            readonly
          />
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="w-1/2">
        <mat-form-field class="w-full">
          <mat-label>{{
              'raw-data.filters.COLUMN_NAME' | transloco
            }}
          </mat-label>
          <mat-select formControlName="columnName">
            @for (i of columns; track i.name) {
              <mat-option [value]="i.name">{{ i.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="flex w-full gap-4">
      <div class="w-1/2">
        <mat-form-field class="w-full">
          <mat-label>{{
              'raw-data.filters.VALUE' | transloco
            }}
          </mat-label>
          <input
            matInput
            type="number"
            formControlName="cellValue"
            [disabled]="dataExists"
          />
        </mat-form-field>
      </div>
      <div class="w-1/2">
        <dx-date-box
          type="datetime"
          formControlName="timestamp"
          placeholder="{{
            'raw-data.filters.PRODUCT_DATE' | transloco
          }}"
          [disabled]="formGroup.controls.timestamp.disabled"
          [inputAttr]="{
            'aria-label':
              'raw-data.filters.PRODUCT_DATE' | transloco,
          }"
        >
        </dx-date-box>
      </div>
    </div>
    <div class="flex w-full gap-4">
      <div class="w-1/2">
        <ng-select
          [items]="units$ | async"
          [searchable]="true"
          appendTo="body"
          [clearable]="true"
          formControlName="unit"
          placeholder="{{
            'raw-data.filters.UNIT' | transloco
          }}"
        >
        </ng-select>
      </div>
    </div>
    <div>
      @if (dataExists) {
        {{
          'raw-data.filters.DATA_ALREADY_EXISTS' | transloco
        }}
      }
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-end space-x-2">
  <cc-cancel-action-button [mat-dialog-close]="true"></cc-cancel-action-button>
  <cc-save-action-button
    (onClick)="addCellData()"
    [disabled]="
      formGroup.invalid ||
      formGroup.controls.columnName.disabled ||
      formGroup.controls.cellValue.disabled ||
      formGroup.controls.unit.disabled ||
      dataExists ||
      disableAddButton
    "
  ></cc-save-action-button>
</mat-dialog-actions>
